import React, { useState, useEffect } from 'react'
import { TableRow, TableBodyCell, Text } from '@lightspeed/design-system-react'
import { formatDateTime, toFixedDecimalPlaces } from '@vend/utilities'
import { UserBadge, useIsMounted } from '@vend/react-utilities'
import ImageSizes from '@vend/types/shared/image-sizes'

import { CASH_MOVEMENT_TYPES } from '../../../constants'
import { ColouredNumber } from '../../util/ColouredNumber'
import { usersStore } from '../../../factories/database/users-store'
import { Movement } from '../utils/types'
import { useCashMovementsTypes } from '../utils/useCashMovementTypes'

interface Props {
  movement: Movement
}

interface PartialUser {
  id: string
  username: string
  displayName: string
  imageSource?: string
  images: ImageSizes | null
  email?: string
  deletedAt?: string
}

export const CashMovementRow: React.FC<Props> = ({ movement }) => {
  const isMountedRef = useIsMounted()
  const getTranslatedType = useCashMovementsTypes()

  const [user, setUser] = useState<PartialUser>({
    id: movement.user_id,
    username: 'Anonymous user',
    displayName: '',
    images: null,
    deletedAt: Date.now().toLocaleString(),
  })

  useEffect(() => {
    usersStore.get(movement.user_id).then(data => {
      if (data && isMountedRef.current) {
        setUser({
          id: movement.user_id,
          username: data.username,
          displayName: data.display_name,
          imageSource: data.image_source,
          images: data.images,
          email: data.email || undefined,
          deletedAt: data.deleted_at || undefined,
        })
      }
    })
  }, [movement.user_id, isMountedRef])
  return (
    <TableRow>
      <TableBodyCell>{formatDateTime(movement.date)}</TableBodyCell>
      <TableBodyCell type="compact" className="wr-hide-on-mobile">
        <UserBadge user={user} size="small" />
      </TableBodyCell>
      <TableBodyCell className="wr-hide-on-tablet">
        <div className="wr-movement-reason">
          <Text tag="div">{getTranslatedType(movement.type)}</Text>
          <Text tag="div" type="supplementary" className="vd-mt1">
            {movement.note}
          </Text>
        </div>
      </TableBodyCell>
      <TableBodyCell align="right" className="vd-text-label vd-pr0">
        {movement.type === CASH_MOVEMENT_TYPES.OPENING_CASH_FLOAT ? (
          <span>{toFixedDecimalPlaces(movement.amount, 2)}</span>
        ) : (
          <ColouredNumber number={toFixedDecimalPlaces(movement.amount, 2)} />
        )}
      </TableBodyCell>
    </TableRow>
  )
}
